// src/theme/atomic/lime.ts
var lime = {
  10: "#112900",
  20: "#225200",
  30: "#347D00",
  40: "#48AD00",
  50: "#58CF04",
  60: "#6BE016",
  70: "#88F03E",
  80: "#AEF779",
  90: "#CCFCA9",
  95: "#E6FFD4",
  99: "#F8FFF2"
};
var lime_default = lime;

export { lime_default as default };
